// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"809":"679941d8","838":"4d4fe1fd"}[chunkId] + ".chunk.css";
};